import config from 'config'
import { getAnalytics, setUserId } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getCurrentParseUser } from '../../market/src/common/user/currentUser'

let analytics

const initializeAnalytics = () => {
  const app = initializeApp(config.firebase)
  analytics = getAnalytics(app)
  setUserId(analytics, getCurrentParseUser()?.id)
}

export const getAppAnalytics = () => {
  if (!analytics) initializeAnalytics()

  return analytics
}
